// extracted by mini-css-extract-plugin
module.exports = {"h1":"Tag_h1__WugkB","h2":"Tag_h2__BEcUM","h3":"Tag_h3__LmRip"};